module.exports = __webpack_public_path__ + "img/van-hoa-en.3c18161b.png";